








import { Component, Vue } from 'vue-property-decorator'
import { DoughnutChart } from 'vue-chart-3'
import {
    ActiveElement,
    ArcElement,
    Chart,
    ChartData,
    ChartEvent,
    ChartOptions,
    DoughnutController,
    LegendElement,
    LegendItem,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { namespace } from 'vuex-class'
import { Pipeline } from '@/api/model/pipeline'
import { ReferralStats } from '@/api/model/referral-stats'
const referrals = namespace('referrals')
Chart.register(DoughnutController, ArcElement)

@Component({
    components: {
        DoughnutChart,
    },
})
export default class ChartReferralPipeline extends Vue {
    @referrals.Getter('selectablePipelines') readonly pipelines!: Pipeline[]
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.State readonly pipelineFilter!: string
    @referrals.Action applyPipelineFilter: ({ id: string }) => Promise<void>

    get chartData(): ChartData {
        if (!this.chartValues) {
            return null
        }

        return {
            labels: this.chartLabels,
            datasets: [
                {
                    data: Object.values(this.chartValues),
                    backgroundColor: this.chartColors,
                    datalabels: {
                        color: 'rgba(255, 255, 255, .75)',
                    },
                },
            ],
        }
    }

    get chartOptions(): ChartOptions<'doughnut'> {
        return {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 3,
            animation: {
                easing: 'easeOutExpo',
            },
            plugins: {
                legend: {
                    position: 'right',
                    onClick: (e: ChartEvent, legendItem: LegendItem, legend: LegendElement) => {
                        // @ts-ignore type defines datasetIndex but it is index at runtime
                        this.onClick(legendItem.index)
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            onClick: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
                if (elements.length === 0) {
                    return
                }

                this.onClick(elements[0].index)
            },
        }
    }

    get chartPlugins(): object[] {
        return [
            ChartDataLabels,
        ]
    }

    get chartValues(): {[key: string]: number} {
        if (!this.referralStats) {
            return {}
        }

        const chartValues = {}
        this.referralStats.countsPerPipeline.forEach(entry => {
            chartValues[entry.pipeline] = entry.count
        })

        return chartValues
    }

    get chartLabels(): string[] {
        const chartLabels = []
        Object.keys(this.chartValues).forEach(id => {
            const pipeline = this.getPipeline(id)
            chartLabels.push(`${(pipeline.name)} (${this.chartValues[id]})`)
        })

        return chartLabels
    }

    get chartColors(): string[] {
        return [
            'rgba(19, 210, 197, 1)',
            'rgba(235, 89, 140, 1)',
            'rgba(247, 131, 35, 1)',
            'rgba(66, 153, 225, 1)',
            'rgba(145, 105, 226, 1)',
            'rgba(231, 220, 30, 1)',
            'rgba(0, 163, 137, 1)',
            'rgba(222, 64, 119, 1)',
            'rgb(125,222,64)',
            'rgb(198,222,64)',
            'rgb(64,67,222)',
        ]
    }

    getPipeline(id: string): Pipeline {
        return this.pipelines.find(v => v.id === id)
    }

    onClick(selectedIndex: number): void {
        const id = Object.keys(this.chartValues)[selectedIndex]

        if (id) {
            this.applyPipelineFilter({
                id: this.pipelineFilter === id ? null : id,
            })
        }
    }
}
